// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.team-area {
  position: relative;
  z-index: 1;
}
.team-area.bg-gradient-image {
  background-image: url('bg4.148d146e6b248814.jpg');
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
}

.single-team-box {
  text-align: center;
  margin-bottom: 30px;
}
.single-team-box .image {
  width: 120px;
  height: 120px;
  overflow: hidden;
  border-radius: 5px;
  position: relative;
  transform: rotate(45deg) translateZ(0px);
  margin-top: 25px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 25px;
}
.single-team-box .image div {
  top: 50%;
  left: 50%;
  width: 170px;
  height: 170px;
  position: absolute;
  transform: rotate(-45deg) translate(0%, -70%);
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
}
.single-team-box .image div.bg-1 {
  background-image: url('team1.8a275fa29abadc78.jpg');
}
.single-team-box .image div.bg-2 {
  background-image: url('team2.8a275fa29abadc78.jpg');
}
.single-team-box .image div.bg-3 {
  background-image: url('team3.8a275fa29abadc78.jpg');
}
.single-team-box .image div.bg-4 {
  background-image: url('team4.8a275fa29abadc78.jpg');
}
.single-team-box .image div.bg-5 {
  background-image: url('team5.8a275fa29abadc78.jpg');
}
.single-team-box .image div.bg-6 {
  background-image: url('team6.8a275fa29abadc78.jpg');
}
.single-team-box .image div.bg-7 {
  background-image: url('team7.8a275fa29abadc78.jpg');
}
.single-team-box .image div.bg-8 {
  background-image: url('team8.8a275fa29abadc78.jpg');
}
.single-team-box .image div.bg-9 {
  background-image: url('team9.8a275fa29abadc78.jpg');
}
.single-team-box .image div.bg-10 {
  background-image: url('team10.8a275fa29abadc78.jpg');
}
.single-team-box .image div.bg-11 {
  background-image: url('team11.8a275fa29abadc78.jpg');
}
.single-team-box .content {
  margin-top: 45px;
}
.single-team-box .content h3 {
  margin-bottom: 8px;
  font-size: 24px;
  font-weight: 600;
}
.single-team-box .content span {
  display: block;
  font-weight: 300;
  color: var(--optionalColor);
}

.team-section-title {
  padding-left: 15px;
}
.team-section-title .sub-title {
  background-color: rgba(2, 152, 148, 0.15);
  transition: var(--transition);
  color: var(--mainColor);
  display: inline-block;
  margin-bottom: 15px;
  letter-spacing: 1px;
  border-radius: 5px;
  padding: 4px 25px;
  font-size: 14px;
  font-weight: 300;
}
.team-section-title .sub-title:hover {
  background-color: var(--mainColor);
  color: var(--whiteColor);
}
.team-section-title h2 {
  margin-bottom: 12px;
  font-size: 40px;
  font-weight: 400;
  font-family: var(--fontFamily2);
}
.team-section-title h2 span {
  color: var(--mainColor);
}
.team-section-title .default-btn {
  margin-top: 10px;
}

.team-member-list {
  padding-right: 15px;
  margin-bottom: -30px;
}

.single-team-member {
  margin-bottom: 30px;
  position: relative;
}
.single-team-member .content {
  background-color: var(--whiteColor);
  border-radius: 0 30px 0 0;
  position: absolute;
  padding: 15px 20px;
  width: 100%;
  bottom: 0;
  left: 0;
}
.single-team-member .content h3 {
  margin-bottom: 0;
  font-size: 24px;
  font-weight: 600;
}
.single-team-member .content span {
  display: block;
  font-weight: 300;
  color: var(--optionalColor);
}

.team-member-area {
  position: relative;
  overflow: hidden;
  z-index: 1;
}

.team-member-card {
  margin-bottom: 30px;
  transition: var(--transition);
}
.team-member-card .team-image {
  position: relative;
  z-index: 1;
}
.team-member-card .team-image img {
  border-radius: 15px;
}
.team-member-card .team-image .social-btn {
  position: absolute;
  right: 20px;
  bottom: -25px;
}
.team-member-card .team-image .social-btn span {
  display: inline-block;
  width: 50px;
  height: 50px;
  color: var(--blackColor);
  border-radius: 50%;
  background-color: var(--whiteColor);
  position: relative;
  font-size: 20px;
  cursor: pointer;
  transition: var(--transition);
}
.team-member-card .team-image .social-btn span i {
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  text-align: center;
  margin-left: -3px;
}
.team-member-card .team-image .social-btn ul {
  padding: 0;
  margin-bottom: 0;
  list-style-type: none;
  position: absolute;
  right: 0;
  bottom: 95px;
}
.team-member-card .team-image .social-btn ul li {
  top: 0;
  right: 0;
  display: block;
  position: absolute;
  transition: var(--transition);
  transform: scale(0);
}
.team-member-card .team-image .social-btn ul li a {
  display: block;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  color: var(--whiteColor);
  position: relative;
  font-size: 18px;
  background-color: var(--mainColor);
  transition: var(--transition);
}
.team-member-card .team-image .social-btn ul li a i {
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  text-align: center;
  margin-left: -1px;
}
.team-member-card .team-image .social-btn ul li a:hover {
  background-color: var(--whiteColor);
  color: var(--mainColor);
}
.team-member-card .team-image .social-btn ul li:nth-child(1) {
  top: -20px;
}
.team-member-card .team-image .social-btn ul li:nth-child(2) {
  top: -80px;
}
.team-member-card .team-image .social-btn ul li:nth-child(3) {
  top: -140px;
}
.team-member-card .team-image .social-btn:hover ul li {
  transform: scale(1);
}
.team-member-card .team-content {
  padding-top: 25px;
  padding-left: 20px;
}
.team-member-card .team-content h3 {
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 0;
}
.team-member-card .team-content span {
  color: var(--mainColor);
  display: inline-block;
  margin-top: 12px;
}
.team-member-card:hover {
  transform: translateY(-5px);
}
.team-member-card:hover .team-image .social-btn span {
  color: var(--whiteColor);
  background-color: var(--mainColor);
}
.team-member-card:hover .team-image .social-btn span i {
  color: var(--whiteColor);
}
.team-member-card.with-white-color .team-content h3 {
  color: var(--whiteColor);
}

.d-none.d-block {
  display: block !important;
}

/* Max width 767px */
@media only screen and (max-width: 767px) {
  .team-area.bg-gradient-image {
    border-bottom: 1px solid #eeeeee;
  }
  .single-team-box .content h3 {
    font-size: 18px;
  }
  .team-section-title {
    padding-left: 0;
    margin-top: 30px;
    text-align: center;
  }
  .team-section-title .sub-title {
    margin-bottom: 12px;
    padding: 3px 15px;
    font-size: 12px;
  }
  .team-section-title h2 {
    font-size: 25px;
  }
  .team-section-title h2 br {
    display: none !important;
  }
  .team-section-title .default-btn {
    margin-top: 3px;
  }
  .team-member-list {
    padding-right: 0;
  }
  .single-team-member .content {
    border-radius: 0 15px 0 0;
    padding: 10px 15px;
  }
  .single-team-member .content h3 {
    font-size: 18px;
  }
  .team-member-card .team-content h3 {
    font-size: 20px;
  }
}
/* Min width 576px to Max width 767px */
/* Min width 768px to Max width 991px */
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .team-area.bg-gradient-image {
    border-bottom: 1px solid #eeeeee;
  }
  .single-team-box .content h3 {
    font-size: 20px;
  }
  .team-member-list {
    padding-right: 0;
  }
  .single-team-member .content h3 {
    font-size: 20px;
  }
  .team-section-title {
    text-align: center;
    margin-top: 30px;
    padding-left: 0;
  }
  .team-section-title .sub-title {
    padding: 4px 20px;
    font-size: 13px;
  }
  .team-section-title h2 {
    font-size: 32px;
  }
  .team-section-title h2 br {
    display: none !important;
  }
  .team-section-title .default-btn {
    margin-top: 5px;
  }
}
/* Min width 992px to Max width 1199px */
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .team-section-title {
    padding-left: 0;
  }
  .single-team-member .content {
    background-color: transparent;
    position: relative;
    border-radius: 0;
    margin-top: 12px;
    padding: 0;
  }
  .single-team-member .content .d-flex {
    display: block !important;
  }
  .single-team-member .content span {
    margin-top: 5px;
  }
  .single-team-member .content h3 {
    font-size: 22px;
  }
  .team-member-card .team-image .social-btn {
    right: 5px;
    bottom: -12px;
  }
}
/* Min width 1200px to Max width 1399px */
@media only screen and (min-width: 1200px) and (max-width: 1399px) {
  .team-member-list {
    padding-right: 0;
  }
  .single-team-member .content {
    padding: 15px;
  }
  .single-team-member .content h3 {
    font-size: 22px;
  }
}
/* Min width 1600px */
*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
/* ! tailwindcss v3.4.15 | MIT License | https://tailwindcss.com */
/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/
*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}
::before,
::after {
  --tw-content: '';
}
/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/
html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}
/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/
body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}
/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/
hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}
/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/
abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}
/*
Remove the default font size and weight for headings.
*/
h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}
/*
Reset links to optimize for opt-in styling instead of opt-out.
*/
a {
  color: inherit;
  text-decoration: inherit;
}
/*
Add the correct font weight in Edge and Safari.
*/
b,
strong {
  font-weight: bolder;
}
/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/
code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}
/*
Add the correct font size in all browsers.
*/
small {
  font-size: 80%;
}
/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/
sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}
sub {
  bottom: -0.25em;
}
sup {
  top: -0.5em;
}
/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/
table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}
/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/
button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}
/*
Remove the inheritance of text transform in Edge and Firefox.
*/
button,
select {
  text-transform: none;
}
/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/
button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}
/*
Use the modern Firefox focus style for all focusable elements.
*/
:-moz-focusring {
  outline: auto;
}
/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/
:-moz-ui-invalid {
  box-shadow: none;
}
/*
Add the correct vertical alignment in Chrome and Firefox.
*/
progress {
  vertical-align: baseline;
}
/*
Correct the cursor style of increment and decrement buttons in Safari.
*/
::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}
/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/
[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}
/*
Remove the inner padding in Chrome and Safari on macOS.
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}
/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/
::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}
/*
Add the correct display in Chrome and Safari.
*/
summary {
  display: list-item;
}
/*
Removes the default spacing and border for appropriate elements.
*/
blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}
fieldset {
  margin: 0;
  padding: 0;
}
legend {
  padding: 0;
}
ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}
/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}
/*
Prevent resizing textareas horizontally by default.
*/
textarea {
  resize: vertical;
}
/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/
input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}
/*
Set the default cursor for buttons.
*/
button,
[role="button"] {
  cursor: pointer;
}
/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}
/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/
img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}
/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/
img,
video {
  max-width: 100%;
  height: auto;
}
/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
.container {
  width: 100%;
}
@media (min-width: 640px) {
  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {
  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {
  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {
  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1536px) {
  .container {
    max-width: 1536px;
  }
}
.collapse {
  visibility: collapse;
}
.static {
  position: static;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.sticky {
  position: sticky;
}
.z-10 {
  z-index: 10;
}
.m-0 {
  margin: 0px;
}
.m-3 {
  margin: 0.75rem;
}
.m-4 {
  margin: 1rem;
}
.m-auto {
  margin: auto;
}
.mx-2 {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.mx-3 {
  margin-left: 0.75rem;
  margin-right: 0.75rem;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-2 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.my-4 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-40 {
  margin-bottom: 10rem;
}
.ml-0\\.5 {
  margin-left: 0.125rem;
}
.ml-1 {
  margin-left: 0.25rem;
}
.ml-2 {
  margin-left: 0.5rem;
}
.ml-5 {
  margin-left: 1.25rem;
}
.ml-auto {
  margin-left: auto;
}
.mr-1 {
  margin-right: 0.25rem;
}
.mr-2 {
  margin-right: 0.5rem;
}
.mr-3 {
  margin-right: 0.75rem;
}
.ms-3 {
  margin-inline-start: 0.75rem;
}
.mt-0 {
  margin-top: 0px;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-10 {
  margin-top: 2.5rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-20 {
  margin-top: 5rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-4 {
  margin-top: 1rem;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.inline {
  display: inline;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.table {
  display: table;
}
.table-cell {
  display: table-cell;
}
.grid {
  display: grid;
}
.\\!hidden {
  display: none !important;
}
.hidden {
  display: none;
}
.size-11 {
  width: 2.75rem;
  height: 2.75rem;
}
.h-12 {
  height: 3rem;
}
.h-2\\.5 {
  height: 0.625rem;
}
.h-5 {
  height: 1.25rem;
}
.h-\\[200px\\] {
  height: 200px;
}
.h-full {
  height: 100%;
}
.w-2\\.5 {
  width: 0.625rem;
}
.w-44 {
  width: 11rem;
}
.w-5 {
  width: 1.25rem;
}
.w-full {
  width: 100%;
}
.max-w-sm {
  max-width: 24rem;
}
.flex-1 {
  flex: 1 1 0%;
}
.flex-shrink-0 {
  flex-shrink: 0;
}
.flex-grow {
  flex-grow: 1;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
.animate-spin {
  animation: spin 1s linear infinite;
}
.cursor-pointer {
  cursor: pointer;
}
.columns-3 {
  columns: 3;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-5 {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}
.flex-row {
  flex-direction: row;
}
.flex-col {
  flex-direction: column;
}
.flex-wrap {
  flex-wrap: wrap;
}
.content-center {
  align-content: center;
}
.items-end {
  align-items: flex-end;
}
.items-center {
  align-items: center;
}
.justify-start {
  justify-content: flex-start;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.justify-around {
  justify-content: space-around;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-4 {
  gap: 1rem;
}
.space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.divide-y > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-gray-100 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(243 244 246 / var(--tw-divide-opacity, 1));
}
.overflow-auto {
  overflow: auto;
}
.overflow-hidden {
  overflow: hidden;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-normal {
  white-space: normal;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.border {
  border-width: 1px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-none {
  border-style: none;
}
.border-gray-200 {
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity, 1));
}
.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.bg-blue-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1));
}
.bg-green-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 244 / var(--tw-bg-opacity, 1));
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-yellow-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 252 232 / var(--tw-bg-opacity, 1));
}
.p-0 {
  padding: 0px;
}
.p-1 {
  padding: 0.25rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-4 {
  padding: 1rem;
}
.p-8 {
  padding: 2rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.pb-2 {
  padding-bottom: 0.5rem;
}
.pb-4 {
  padding-bottom: 1rem;
}
.pl-0 {
  padding-left: 0px;
}
.pl-5 {
  padding-left: 1.25rem;
}
.pr-0 {
  padding-right: 0px;
}
.pt-0 {
  padding-top: 0px;
}
.pt-2 {
  padding-top: 0.5rem;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.text-start {
  text-align: start;
}
.text-end {
  text-align: end;
}
.align-middle {
  vertical-align: middle;
}
.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-bold {
  font-weight: 700;
}
.font-light {
  font-weight: 300;
}
.font-medium {
  font-weight: 500;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.leading-\\[18px\\] {
  line-height: 18px;
}
.text-blue-500 {
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity, 1));
}
.text-blue-600 {
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}
.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.text-gray-600 {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}
.text-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}
.text-green-800 {
  --tw-text-opacity: 1;
  color: rgb(22 101 52 / var(--tw-text-opacity, 1));
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-yellow-800 {
  --tw-text-opacity: 1;
  color: rgb(133 77 14 / var(--tw-text-opacity, 1));
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline {
  outline-style: solid;
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-300 {
  transition-duration: 300ms;
}
.hover\\:bg-blue-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-teal-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(17 94 89 / var(--tw-bg-opacity, 1));
}
.hover\\:underline:hover {
  text-decoration-line: underline;
}
.hover\\:shadow-lg:hover {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus\\:ring-4:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-blue-300:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(147 197 253 / var(--tw-ring-opacity, 1));
}
@media (min-width: 768px) {
  .md\\:col-span-1 {
    grid-column: span 1 / span 1;
  }
  .md\\:col-span-2 {
    grid-column: span 2 / span 2;
  }
  .md\\:block {
    display: block;
  }
  .md\\:hidden {
    display: none;
  }
  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .md\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .md\\:justify-center {
    justify-content: center;
  }
  .md\\:p-2 {
    padding: 0.5rem;
  }
}
@media (prefers-color-scheme: dark) {
  .dark\\:border-gray-700 {
    --tw-border-opacity: 1;
    border-color: rgb(55 65 81 / var(--tw-border-opacity, 1));
  }
  .dark\\:bg-gray-700 {
    --tw-bg-opacity: 1;
    background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
  }
  .dark\\:bg-gray-800 {
    --tw-bg-opacity: 1;
    background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
  }
  .dark\\:text-gray-200 {
    --tw-text-opacity: 1;
    color: rgb(229 231 235 / var(--tw-text-opacity, 1));
  }
  .dark\\:hover\\:bg-gray-600:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(75 85 99 / var(--tw-bg-opacity, 1));
  }
  .dark\\:hover\\:bg-gray-700:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
  }
  .dark\\:hover\\:text-white:hover {
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1));
  }
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/components/common/team/team.component.scss","webpack://./src/app/components/pages/team-page/team-page.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,UAAA;ACCJ;ADCI;EAEQ,iDAAA;EACA,kCAAA;EACA,4BAAA;EACA,sBAAA;ACAZ;;ADIA;EACI,kBAAA;EACA,mBAAA;ACDJ;ADGI;EACI,YAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,wCAAA;EAEI,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;ACFZ;ADIQ;EACI,QAAA;EACA,SAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,6CAAA;EAEI,kCAAA;EACA,4BAAA;EACA,sBAAA;ACHhB;ADKY;EACI,mDAAA;ACHhB;ADKY;EACI,mDAAA;ACHhB;ADKY;EACI,mDAAA;ACHhB;ADKY;EACI,mDAAA;ACHhB;ADKY;EACI,mDAAA;ACHhB;ADKY;EACI,mDAAA;ACHhB;ADKY;EACI,mDAAA;ACHhB;ADKY;EACI,mDAAA;ACHhB;ADKY;EACI,mDAAA;ACHhB;ADKY;EACI,oDAAA;ACHhB;ADKY;EACI,oDAAA;ACHhB;ADOI;EACI,gBAAA;ACLR;ADOQ;EACI,kBAAA;EAEI,eAAA;EACA,gBAAA;ACNhB;ADSQ;EACI,cAAA;EACA,gBAAA;EACA,2BAAA;ACPZ;;ADWA;EACI,kBAAA;ACRJ;ADUI;EACI,yCAAA;EACA,6BAAA;EACA,uBAAA;EACA,qBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EAEI,eAAA;EACA,gBAAA;ACTZ;ADWQ;EACI,kCAAA;EACA,wBAAA;ACTZ;ADYI;EACI,mBAAA;EAEI,eAAA;EACA,gBAAA;EACA,+BAAA;ACXZ;ADaQ;EACI,uBAAA;ACXZ;ADcI;EACI,gBAAA;ACZR;;ADeA;EACI,mBAAA;EACA,oBAAA;ACZJ;;ADcA;EACI,mBAAA;EACA,kBAAA;ACXJ;ADaI;EACI,mCAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,OAAA;ACXR;ADaQ;EACI,gBAAA;EAEI,eAAA;EACA,gBAAA;ACZhB;ADeQ;EACI,cAAA;EACA,gBAAA;EACA,2BAAA;ACbZ;;ADiBA;EACI,kBAAA;EACA,gBAAA;EACA,UAAA;ACdJ;;ADgBA;EACI,mBAAA;EACA,6BAAA;ACbJ;ADeI;EACI,kBAAA;EACA,UAAA;ACbR;ADeQ;EACI,mBAAA;ACbZ;ADeQ;EACI,kBAAA;EACA,WAAA;EACA,aAAA;ACbZ;ADeY;EACI,qBAAA;EACA,WAAA;EACA,YAAA;EACA,wBAAA;EACA,kBAAA;EACA,mCAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,6BAAA;ACbhB;ADegB;EACI,kBAAA;EACA,OAAA;EACA,QAAA;EACA,QAAA;EACA,2BAAA;EACA,kBAAA;EACA,iBAAA;ACbpB;ADgBY;EACI,UAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,QAAA;EACA,YAAA;ACdhB;ADgBgB;EACI,MAAA;EACA,QAAA;EACA,cAAA;EACA,kBAAA;EACA,6BAAA;EACA,mBAAA;ACdpB;ADgBoB;EACI,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,wBAAA;EACA,kBAAA;EACA,eAAA;EACA,kCAAA;EACA,6BAAA;ACdxB;ADgBwB;EACI,kBAAA;EACA,OAAA;EACA,QAAA;EACA,QAAA;EACA,2BAAA;EACA,kBAAA;EACA,iBAAA;ACd5B;ADgBwB;EACI,mCAAA;EACA,uBAAA;ACd5B;ADiBoB;EACI,UAAA;ACfxB;ADiBoB;EACI,UAAA;ACfxB;ADiBoB;EACI,WAAA;ACfxB;ADqBoB;EACI,mBAAA;ACnBxB;ADyBI;EAEQ,iBAAA;EACA,kBAAA;ACxBZ;AD0BQ;EACI,eAAA;EACA,gBAAA;EACA,gBAAA;ACxBZ;AD0BQ;EACI,uBAAA;EACA,qBAAA;EACA,gBAAA;ACxBZ;AD2BI;EACI,2BAAA;ACzBR;AD6BgB;EACI,wBAAA;EACA,kCAAA;AC3BpB;AD6BoB;EACI,wBAAA;AC3BxB;ADmCY;EACI,wBAAA;ACjChB;;ADuCI;EACI,yBAAA;ACpCR;;ADwCA,oBAAA;AACA;EAGQ;IACI,gCAAA;ECvCV;ED4CU;IACI,eAAA;EC1Cd;ED8CE;IACI,eAAA;IACA,gBAAA;IACA,kBAAA;EC5CN;ED8CM;IACI,mBAAA;IACA,iBAAA;IACA,eAAA;EC5CV;ED8CM;IACI,eAAA;EC5CV;ED8CU;IACI,wBAAA;EC5Cd;ED+CM;IACI,eAAA;EC7CV;EDgDE;IACI,gBAAA;EC9CN;EDiDM;IACI,yBAAA;IACA,kBAAA;EC/CV;EDiDU;IACI,eAAA;EC/Cd;EDqDU;IACI,eAAA;ECnDd;AACF;ADyDA,uCAAA;AAGA,uCAAA;AACA;EAGQ;IACI,gCAAA;EC3DV;EDgEU;IACI,eAAA;EC9Dd;EDkEE;IACI,gBAAA;EChEN;EDoEU;IACI,eAAA;EClEd;EDsEE;IACI,kBAAA;IACA,gBAAA;IACA,eAAA;ECpEN;EDsEM;IACI,iBAAA;IACA,eAAA;ECpEV;EDsEM;IACI,eAAA;ECpEV;EDsEU;IACI,wBAAA;ECpEd;EDuEM;IACI,eAAA;ECrEV;AACF;AD0EA,wCAAA;AACA;EAEI;IACI,eAAA;ECzEN;ED4EM;IACI,6BAAA;IACA,kBAAA;IACA,gBAAA;IACA,gBAAA;IACA,UAAA;EC1EV;ED4EU;IACI,yBAAA;EC1Ed;ED4EU;IACI,eAAA;EC1Ed;ED4EU;IACI,eAAA;EC1Ed;EDgFU;IACI,UAAA;IACA,aAAA;EC9Ed;AACF;ADoFA,yCAAA;AACA;EAEI;IACI,gBAAA;ECnFN;EDsFM;IACI,aAAA;ECpFV;EDsFU;IACI,eAAA;ECpFd;AACF;AD0FA,qBAAA;AAGA;EAAA,wBAAA;EAAA,wBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,cAAA;EAAA,cAAA;EAAA,cAAA;EAAA,eAAA;EAAA,eAAA;EAAA,aAAA;EAAA,aAAA;EAAA,kBAAA;EAAA,sCAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,eAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,kBAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,sCAAA;EAAA,kCAAA;EAAA,2BAAA;EAAA,sBAAA;EAAA,8BAAA;EAAA,YAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,cAAA;EAAA,gBAAA;EAAA,aAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA,2BAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,yBAAA;EAAA,sBAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,qBAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,wBAAA;EAAA,wBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,cAAA;EAAA,cAAA;EAAA,cAAA;EAAA,eAAA;EAAA,eAAA;EAAA,aAAA;EAAA,aAAA;EAAA,kBAAA;EAAA,sCAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,eAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,kBAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,sCAAA;EAAA,kCAAA;EAAA,2BAAA;EAAA,sBAAA;EAAA,8BAAA;EAAA,YAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,cAAA;EAAA,gBAAA;EAAA,aAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA,2BAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,yBAAA;EAAA,sBAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,qBAAA;EAAA,qBAAA;AAAA;AAAA,kEAAA;AAAA;;;CAAA;AAAA;;;EAAA,sBAAA,EAAA,MAAA;EAAA,eAAA,EAAA,MAAA;EAAA,mBAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;AAAA;AAAA;;EAAA,gBAAA;AAAA;AAAA;;;;;;;;CAAA;AAAA;;EAAA,gBAAA,EAAA,MAAA;EAAA,8BAAA,EAAA,MAAA,EAAA,MAAA;EAAA,WAAA,EAAA,MAAA;EAAA,+HAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,+BAAA,EAAA,MAAA;EAAA,wCAAA,EAAA,MAAA;AAAA;AAAA;;;CAAA;AAAA;EAAA,SAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;AAAA;AAAA;;;;CAAA;AAAA;EAAA,SAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;AAAA;AAAA;;CAAA;AAAA;EAAA,yCAAA;UAAA,iCAAA;AAAA;AAAA;;CAAA;AAAA;;;;;;EAAA,kBAAA;EAAA,oBAAA;AAAA;AAAA;;CAAA;AAAA;EAAA,cAAA;EAAA,wBAAA;AAAA;AAAA;;CAAA;AAAA;;EAAA,mBAAA;AAAA;AAAA;;;;;CAAA;AAAA;;;;EAAA,+GAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,+BAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;AAAA;AAAA;;CAAA;AAAA;EAAA,cAAA;AAAA;AAAA;;CAAA;AAAA;;EAAA,cAAA;EAAA,cAAA;EAAA,kBAAA;EAAA,wBAAA;AAAA;AAAA;EAAA,eAAA;AAAA;AAAA;EAAA,WAAA;AAAA;AAAA;;;;CAAA;AAAA;EAAA,cAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;EAAA,yBAAA,EAAA,MAAA;AAAA;AAAA;;;;CAAA;AAAA;;;;;EAAA,oBAAA,EAAA,MAAA;EAAA,8BAAA,EAAA,MAAA;EAAA,gCAAA,EAAA,MAAA;EAAA,eAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;EAAA,uBAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;EAAA,SAAA,EAAA,MAAA;EAAA,UAAA,EAAA,MAAA;AAAA;AAAA;;CAAA;AAAA;;EAAA,oBAAA;AAAA;AAAA;;;CAAA;AAAA;;;;EAAA,0BAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,sBAAA,EAAA,MAAA;AAAA;AAAA;;CAAA;AAAA;EAAA,aAAA;AAAA;AAAA;;CAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;;CAAA;AAAA;EAAA,wBAAA;AAAA;AAAA;;CAAA;AAAA;;EAAA,YAAA;AAAA;AAAA;;;CAAA;AAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;AAAA;AAAA;;CAAA;AAAA;EAAA,wBAAA;AAAA;AAAA;;;CAAA;AAAA;EAAA,0BAAA,EAAA,MAAA;EAAA,aAAA,EAAA,MAAA;AAAA;AAAA;;CAAA;AAAA;EAAA,kBAAA;AAAA;AAAA;;CAAA;AAAA;;;;;;;;;;;;;EAAA,SAAA;AAAA;AAAA;EAAA,SAAA;EAAA,UAAA;AAAA;AAAA;EAAA,UAAA;AAAA;AAAA;;;EAAA,gBAAA;EAAA,SAAA;EAAA,UAAA;AAAA;AAAA;;CAAA;AAAA;EAAA,UAAA;AAAA;AAAA;;CAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;;;CAAA;AAAA;;EAAA,UAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;AAAA;AAAA;;CAAA;AAAA;;EAAA,eAAA;AAAA;AAAA;;CAAA;AAAA;EAAA,eAAA;AAAA;AAAA;;;;CAAA;AAAA;;;;;;;;EAAA,cAAA,EAAA,MAAA;EAAA,sBAAA,EAAA,MAAA;AAAA;AAAA;;CAAA;AAAA;;EAAA,eAAA;EAAA,YAAA;AAAA;AAAA,wEAAA;AAAA;EAAA,aAAA;AAAA;AACA;EAAA,WAAA;AAAA;AAAA;EAAA;IAAA,gBAAA;EAAA;AAAA;AAAA;EAAA;IAAA,gBAAA;EAAA;AAAA;AAAA;EAAA;IAAA,iBAAA;EAAA;AAAA;AAAA;EAAA;IAAA,iBAAA;EAAA;AAAA;AAAA;EAAA;IAAA,iBAAA;EAAA;AAAA;AACA;EAAA,oBAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,eAAA;AAAA;AAAA;EAAA,kBAAA;AAAA;AAAA;EAAA,kBAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,WAAA;AAAA;AAAA;EAAA,WAAA;AAAA;AAAA;EAAA,eAAA;AAAA;AAAA;EAAA,YAAA;AAAA;AAAA;EAAA,YAAA;AAAA;AAAA;EAAA,mBAAA;EAAA,oBAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,iBAAA;EAAA,kBAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,gBAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,oBAAA;AAAA;AAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,oBAAA;AAAA;AAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,oBAAA;AAAA;AAAA;EAAA,iBAAA;AAAA;AAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,oBAAA;AAAA;AAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,4BAAA;AAAA;AAAA;EAAA,eAAA;AAAA;AAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,kBAAA;AAAA;AAAA;EAAA,kBAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,cAAA;AAAA;AAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,eAAA;AAAA;AAAA;EAAA,aAAA;AAAA;AAAA;EAAA,oBAAA;AAAA;AAAA;EAAA,cAAA;AAAA;AAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,aAAA;AAAA;AAAA;EAAA,wBAAA;AAAA;AAAA;EAAA,aAAA;AAAA;AAAA;EAAA,cAAA;EAAA,eAAA;AAAA;AAAA;EAAA,YAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,eAAA;AAAA;AAAA;EAAA,aAAA;AAAA;AAAA;EAAA,YAAA;AAAA;AAAA;EAAA,eAAA;AAAA;AAAA;EAAA,YAAA;AAAA;AAAA;EAAA,cAAA;AAAA;AAAA;EAAA,WAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,YAAA;AAAA;AAAA;EAAA,cAAA;AAAA;AAAA;EAAA,YAAA;AAAA;AAAA;EAAA;IAAA,yBAAA;EAAA;AAAA;AAAA;EAAA,kCAAA;AAAA;AAAA;EAAA,eAAA;AAAA;AAAA;EAAA,UAAA;AAAA;AAAA;EAAA,gDAAA;AAAA;AAAA;EAAA,gDAAA;AAAA;AAAA;EAAA,gDAAA;AAAA;AAAA;EAAA,gDAAA;AAAA;AAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,sBAAA;AAAA;AAAA;EAAA,eAAA;AAAA;AAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,2BAAA;AAAA;AAAA;EAAA,uBAAA;AAAA;AAAA;EAAA,8BAAA;AAAA;AAAA;EAAA,6BAAA;AAAA;AAAA;EAAA,WAAA;AAAA;AAAA;EAAA,SAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,8DAAA;EAAA,uDAAA;AAAA;AAAA;EAAA,wBAAA;EAAA,kEAAA;EAAA,2DAAA;AAAA;AAAA;EAAA,sBAAA;EAAA,4DAAA;AAAA;AAAA;EAAA,cAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,gBAAA;EAAA,uBAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,sBAAA;AAAA;AAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,iBAAA;AAAA;AAAA;EAAA,wBAAA;AAAA;AAAA;EAAA,kBAAA;AAAA;AAAA;EAAA,sBAAA;EAAA,4DAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,sDAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,2DAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,4DAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,4DAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,4DAAA;AAAA;AAAA;EAAA,YAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,eAAA;AAAA;AAAA;EAAA,aAAA;AAAA;AAAA;EAAA,aAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,uBAAA;AAAA;AAAA;EAAA,mBAAA;EAAA,sBAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,uBAAA;AAAA;AAAA;EAAA,iBAAA;EAAA,oBAAA;AAAA;AAAA;EAAA,sBAAA;AAAA;AAAA;EAAA,oBAAA;AAAA;AAAA;EAAA,iBAAA;AAAA;AAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,kBAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,kBAAA;AAAA;AAAA;EAAA,iBAAA;AAAA;AAAA;EAAA,iBAAA;AAAA;AAAA;EAAA,eAAA;AAAA;AAAA;EAAA,sBAAA;AAAA;AAAA;EAAA,mBAAA;EAAA,oBAAA;AAAA;AAAA;EAAA,eAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,mBAAA;EAAA,oBAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,iBAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,yBAAA;AAAA;AAAA;EAAA,iBAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,kDAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,iDAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,mDAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,gDAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,gDAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,iDAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,mDAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,iDAAA;AAAA;AAAA;EAAA,0EAAA;EAAA,8FAAA;EAAA,uGAAA;AAAA;AAAA;EAAA,+EAAA;EAAA,mGAAA;EAAA,uGAAA;AAAA;AAAA;EAAA,6EAAA;EAAA,iGAAA;EAAA,uGAAA;AAAA;AAAA;EAAA,oBAAA;AAAA;AAAA;EAAA,iLAAA;AAAA;AAAA;EAAA,wBAAA;EAAA,wDAAA;EAAA,0BAAA;AAAA;AAAA;EAAA,0BAAA;AAAA;AAheA;EAAA,kBAgeA;EAheA,0DAAA;AAgeA;AAheA;EAAA,kBAgeA;EAheA,4DAAA;AAgeA;AAheA;EAAA,kBAgeA;EAheA,yDAAA;AAgeA;AAheA;EAAA,+BAAA;AAgeA;AAheA;EAAA,+EAgeA;EAheA,mGAgeA;EAheA,uGAAA;AAgeA;AAheA;EAAA,8BAgeA;EAheA,mBAAA;AAgeA;AAheA;EAAA,2GAgeA;EAheA,yGAgeA;EAheA,4FAAA;AAgeA;AAheA;EAAA,oBAgeA;EAheA,6DAAA;AAgeA;AAheA;EAAA;IAAA,4BAAA;EAgeA;EAheA;IAAA,4BAAA;EAgeA;EAheA;IAAA,cAAA;EAgeA;EAheA;IAAA,aAAA;EAgeA;EAheA;IAAA,gDAAA;EAgeA;EAheA;IAAA,gDAAA;EAgeA;EAheA;IAAA,uBAAA;EAgeA;EAheA;IAAA,eAAA;EAgeA;AAAA;AAheA;EAAA;IAAA,sBAgeA;IAheA,yDAAA;EAgeA;EAheA;IAAA,kBAgeA;IAheA,yDAAA;EAgeA;EAheA;IAAA,kBAgeA;IAheA,yDAAA;EAgeA;EAheA;IAAA,oBAgeA;IAheA,mDAAA;EAgeA;EAheA;IAAA,kBAgeA;IAheA,yDAAA;EAgeA;EAheA;IAAA,kBAgeA;IAheA,yDAAA;EAgeA;EAheA;IAAA,oBAgeA;IAheA,mDAAA;EAgeA;AAAA;AC46BA,w9wCAAw9wC","sourcesContent":[".team-area {\n    position: relative;\n    z-index: 1;\n\n    &.bg-gradient-image {\n        background: {\n            image: url(../../../../assets/img/bg/bg4.jpg);\n            position: center center;\n            repeat: no-repeat;\n            size: cover;\n        };\n    }\n}\n.single-team-box {\n    text-align: center;\n    margin-bottom: 30px;\n\n    .image {\n        width: 120px;\n        height: 120px;\n        overflow: hidden;\n        border-radius: 5px;\n        position: relative;\n        transform: rotate(45deg) translateZ(0px);\n        margin: {\n            top: 25px;\n            left: auto;\n            right: auto;\n            bottom: 25px;\n        };\n        div {\n            top: 50%;\n            left: 50%;\n            width: 170px;\n            height: 170px;\n            position: absolute;\n            transform: rotate(-45deg) translate(0%, -70%);\n            background: {\n                position: center center;\n                repeat: no-repeat;\n                size: cover;\n            };\n            &.bg-1 {\n                background-image: url(../../../../assets/img/team/team1.jpg);\n            }\n            &.bg-2 {\n                background-image: url(../../../../assets/img/team/team2.jpg);\n            }\n            &.bg-3 {\n                background-image: url(../../../../assets/img/team/team3.jpg);\n            }\n            &.bg-4 {\n                background-image: url(../../../../assets/img/team/team4.jpg);\n            }\n            &.bg-5 {\n                background-image: url(../../../../assets/img/team/team5.jpg);\n            }\n            &.bg-6 {\n                background-image: url(../../../../assets/img/team/team6.jpg);\n            }\n            &.bg-7 {\n                background-image: url(../../../../assets/img/team/team7.jpg);\n            }\n            &.bg-8 {\n                background-image: url(../../../../assets/img/team/team8.jpg);\n            }\n            &.bg-9 {\n                background-image: url(../../../../assets/img/team/team9.jpg);\n            }\n            &.bg-10 {\n                background-image: url(../../../../assets/img/team/team10.jpg);\n            }\n            &.bg-11 {\n                background-image: url(../../../../assets/img/team/team11.jpg);\n            }\n        }\n    }\n    .content {\n        margin-top: 45px;\n\n        h3 {\n            margin-bottom: 8px;\n            font: {\n                size: 24px;\n                weight: 600;\n            };\n        }\n        span {\n            display: block;\n            font-weight: 300;\n            color: var(--optionalColor);\n        }\n    }\n}\n.team-section-title {\n    padding-left: 15px;\n\n    .sub-title {\n        background-color: rgba(2, 152, 148, .15);\n        transition: var(--transition);\n        color: var(--mainColor);\n        display: inline-block;\n        margin-bottom: 15px;\n        letter-spacing: 1px;\n        border-radius: 5px;\n        padding: 4px 25px;\n        font: {\n            size: 14px;\n            weight: 300;\n        };\n        &:hover {\n            background-color: var(--mainColor);\n            color: var(--whiteColor);\n        }\n    }\n    h2 {\n        margin-bottom: 12px;\n        font: {\n            size: 40px;\n            weight: 400;\n            family: var(--fontFamily2);\n        };\n        span {\n            color: var(--mainColor);\n        }\n    }\n    .default-btn {\n        margin-top: 10px;\n    }\n}\n.team-member-list {\n    padding-right: 15px;\n    margin-bottom: -30px;\n}\n.single-team-member {\n    margin-bottom: 30px;\n    position: relative;\n\n    .content {\n        background-color: var(--whiteColor);\n        border-radius: 0 30px 0 0;\n        position: absolute;\n        padding: 15px 20px;\n        width: 100%;\n        bottom: 0;\n        left: 0;\n\n        h3 {\n            margin-bottom: 0;\n            font: {\n                size: 24px;\n                weight: 600;\n            };\n        }\n        span {\n            display: block;\n            font-weight: 300;\n            color: var(--optionalColor);\n        }\n    }\n}\n.team-member-area {\n    position: relative;\n    overflow: hidden;\n    z-index: 1;\n}\n.team-member-card {\n    margin-bottom: 30px;\n    transition: var(--transition);\n\n    .team-image {\n        position: relative;\n        z-index: 1;\n\n        img {\n            border-radius: 15px;\n        }\n        .social-btn {\n            position: absolute;\n            right: 20px;\n            bottom: -25px;\n\n            span {\n                display: inline-block;\n                width: 50px;\n                height: 50px;\n                color: var(--blackColor);\n                border-radius: 50%;\n                background-color: var(--whiteColor);\n                position: relative;\n                font-size: 20px;\n                cursor: pointer;\n                transition: var(--transition);\n\n                i {\n                    position: absolute;\n                    left: 0;\n                    right: 0;\n                    top: 50%;\n                    transform: translateY(-50%);\n                    text-align: center;\n                    margin-left: -3px;\n                }\n            }\n            ul {\n                padding: 0;\n                margin-bottom: 0;\n                list-style-type: none;\n                position: absolute;\n                right: 0;\n                bottom: 95px;\n\n                li {\n                    top: 0;\n                    right: 0;\n                    display: block;\n                    position: absolute;\n                    transition: var(--transition);\n                    transform: scale(0);\n\n                    a {\n                        display: block;\n                        width: 50px;\n                        height: 50px;\n                        border-radius: 50%;\n                        color: var(--whiteColor);\n                        position: relative;\n                        font-size: 18px;\n                        background-color: var(--mainColor);\n                        transition: var(--transition);\n\n                        i {\n                            position: absolute;\n                            left: 0;\n                            right: 0;\n                            top: 50%;\n                            transform: translateY(-50%);\n                            text-align: center;\n                            margin-left: -1px;\n                        }\n                        &:hover {\n                            background-color: var(--whiteColor);\n                            color: var(--mainColor);\n                        }\n                    }\n                    &:nth-child(1) {\n                        top: -20px;\n                    }\n                    &:nth-child(2) {\n                        top: -80px;\n                    }\n                    &:nth-child(3) {\n                        top: -140px;\n                    }\n                }\n            }\n            &:hover {\n                ul {\n                    li {\n                        transform: scale(1);\n                    }\n                }\n            }\n        }\n    }\n    .team-content {\n        padding: {\n            top: 25px;\n            left: 20px;\n        };\n        h3 {\n            font-size: 24px;\n            font-weight: 600;\n            margin-bottom: 0;\n        }\n        span {\n            color: var(--mainColor);\n            display: inline-block;\n            margin-top: 12px;\n        }\n    }\n    &:hover {\n        transform: translateY(-5px);\n\n        .team-image {\n            .social-btn {\n                span {\n                    color: var(--whiteColor);\n                    background-color: var(--mainColor);\n\n                    i {\n                        color: var(--whiteColor);\n                    }\n                }\n            }\n        }\n    }\n    &.with-white-color {\n        .team-content {\n            h3 {\n                color: var(--whiteColor);\n            }\n        }\n    }\n}\n.d-none {\n    &.d-block {\n        display: block !important;\n    }\n}\n\n/* Max width 767px */\n@media only screen and (max-width : 767px) {\n\n    .team-area {\n        &.bg-gradient-image {\n            border-bottom: 1px solid #eeeeee;\n        }\n    }\n    .single-team-box {\n        .content {\n            h3 {\n                font-size: 18px;\n            }\n        }\n    }\n    .team-section-title {\n        padding-left: 0;\n        margin-top: 30px;\n        text-align: center;\n\n        .sub-title {\n            margin-bottom: 12px;\n            padding: 3px 15px;\n            font-size: 12px;\n        }\n        h2 {\n            font-size: 25px;\n\n            br {\n                display: none !important;\n            }\n        }\n        .default-btn {\n            margin-top: 3px;\n        }\n    }\n    .team-member-list {\n        padding-right: 0;\n    }\n    .single-team-member {\n        .content {\n            border-radius: 0 15px 0 0;\n            padding: 10px 15px;\n\n            h3 {\n                font-size: 18px;\n            }\n        }\n    }\n    .team-member-card {\n        .team-content {\n            h3 {\n                font-size: 20px;\n            }\n        }\n    }\n\n}\n\n/* Min width 576px to Max width 767px */\n@media only screen and (min-width : 576px) and (max-width : 767px) {}\n\n/* Min width 768px to Max width 991px */\n@media only screen and (min-width : 768px) and (max-width : 991px) {\n\n    .team-area {\n        &.bg-gradient-image {\n            border-bottom: 1px solid #eeeeee;\n        }\n    }\n    .single-team-box {\n        .content {\n            h3 {\n                font-size: 20px;\n            }\n        }\n    }\n    .team-member-list {\n        padding-right: 0;\n    }\n    .single-team-member {\n        .content {\n            h3 {\n                font-size: 20px;\n            }\n        }\n    }\n    .team-section-title {\n        text-align: center;\n        margin-top: 30px;\n        padding-left: 0;\n\n        .sub-title {\n            padding: 4px 20px;\n            font-size: 13px;\n        }\n        h2 {\n            font-size: 32px;\n\n            br {\n                display: none !important;\n            }\n        }\n        .default-btn {\n            margin-top: 5px;\n        }\n    }\n\n}\n\n/* Min width 992px to Max width 1199px */\n@media only screen and (min-width : 992px) and (max-width : 1199px) {\n\n    .team-section-title {\n        padding-left: 0;\n    }\n    .single-team-member {\n        .content {\n            background-color: transparent;\n            position: relative;\n            border-radius: 0;\n            margin-top: 12px;\n            padding: 0;\n\n            .d-flex {\n                display: block !important;\n            }\n            span {\n                margin-top: 5px;\n            }\n            h3 {\n                font-size: 22px;\n            }\n        }\n    }\n    .team-member-card {\n        .team-image {\n            .social-btn {\n                right: 5px;\n                bottom: -12px;\n            }\n        }\n    }\n\n}\n\n/* Min width 1200px to Max width 1399px */\n@media only screen and (min-width: 1200px) and (max-width: 1399px) {\n\n    .team-member-list {\n        padding-right: 0;\n    }\n    .single-team-member {\n        .content {\n            padding: 15px;\n\n            h3 {\n                font-size: 22px;\n            }\n        }\n    }\n\n}\n\n/* Min width 1600px */\n@media only screen and (min-width: 1600px) {}\n\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n",".team-area {\n  position: relative;\n  z-index: 1;\n}\n.team-area.bg-gradient-image {\n  background-image: url(../../../../assets/img/bg/bg4.jpg);\n  background-position: center center;\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n\n.single-team-box {\n  text-align: center;\n  margin-bottom: 30px;\n}\n.single-team-box .image {\n  width: 120px;\n  height: 120px;\n  overflow: hidden;\n  border-radius: 5px;\n  position: relative;\n  transform: rotate(45deg) translateZ(0px);\n  margin-top: 25px;\n  margin-left: auto;\n  margin-right: auto;\n  margin-bottom: 25px;\n}\n.single-team-box .image div {\n  top: 50%;\n  left: 50%;\n  width: 170px;\n  height: 170px;\n  position: absolute;\n  transform: rotate(-45deg) translate(0%, -70%);\n  background-position: center center;\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n.single-team-box .image div.bg-1 {\n  background-image: url(../../../../assets/img/team/team1.jpg);\n}\n.single-team-box .image div.bg-2 {\n  background-image: url(../../../../assets/img/team/team2.jpg);\n}\n.single-team-box .image div.bg-3 {\n  background-image: url(../../../../assets/img/team/team3.jpg);\n}\n.single-team-box .image div.bg-4 {\n  background-image: url(../../../../assets/img/team/team4.jpg);\n}\n.single-team-box .image div.bg-5 {\n  background-image: url(../../../../assets/img/team/team5.jpg);\n}\n.single-team-box .image div.bg-6 {\n  background-image: url(../../../../assets/img/team/team6.jpg);\n}\n.single-team-box .image div.bg-7 {\n  background-image: url(../../../../assets/img/team/team7.jpg);\n}\n.single-team-box .image div.bg-8 {\n  background-image: url(../../../../assets/img/team/team8.jpg);\n}\n.single-team-box .image div.bg-9 {\n  background-image: url(../../../../assets/img/team/team9.jpg);\n}\n.single-team-box .image div.bg-10 {\n  background-image: url(../../../../assets/img/team/team10.jpg);\n}\n.single-team-box .image div.bg-11 {\n  background-image: url(../../../../assets/img/team/team11.jpg);\n}\n.single-team-box .content {\n  margin-top: 45px;\n}\n.single-team-box .content h3 {\n  margin-bottom: 8px;\n  font-size: 24px;\n  font-weight: 600;\n}\n.single-team-box .content span {\n  display: block;\n  font-weight: 300;\n  color: var(--optionalColor);\n}\n\n.team-section-title {\n  padding-left: 15px;\n}\n.team-section-title .sub-title {\n  background-color: rgba(2, 152, 148, 0.15);\n  transition: var(--transition);\n  color: var(--mainColor);\n  display: inline-block;\n  margin-bottom: 15px;\n  letter-spacing: 1px;\n  border-radius: 5px;\n  padding: 4px 25px;\n  font-size: 14px;\n  font-weight: 300;\n}\n.team-section-title .sub-title:hover {\n  background-color: var(--mainColor);\n  color: var(--whiteColor);\n}\n.team-section-title h2 {\n  margin-bottom: 12px;\n  font-size: 40px;\n  font-weight: 400;\n  font-family: var(--fontFamily2);\n}\n.team-section-title h2 span {\n  color: var(--mainColor);\n}\n.team-section-title .default-btn {\n  margin-top: 10px;\n}\n\n.team-member-list {\n  padding-right: 15px;\n  margin-bottom: -30px;\n}\n\n.single-team-member {\n  margin-bottom: 30px;\n  position: relative;\n}\n.single-team-member .content {\n  background-color: var(--whiteColor);\n  border-radius: 0 30px 0 0;\n  position: absolute;\n  padding: 15px 20px;\n  width: 100%;\n  bottom: 0;\n  left: 0;\n}\n.single-team-member .content h3 {\n  margin-bottom: 0;\n  font-size: 24px;\n  font-weight: 600;\n}\n.single-team-member .content span {\n  display: block;\n  font-weight: 300;\n  color: var(--optionalColor);\n}\n\n.team-member-area {\n  position: relative;\n  overflow: hidden;\n  z-index: 1;\n}\n\n.team-member-card {\n  margin-bottom: 30px;\n  transition: var(--transition);\n}\n.team-member-card .team-image {\n  position: relative;\n  z-index: 1;\n}\n.team-member-card .team-image img {\n  border-radius: 15px;\n}\n.team-member-card .team-image .social-btn {\n  position: absolute;\n  right: 20px;\n  bottom: -25px;\n}\n.team-member-card .team-image .social-btn span {\n  display: inline-block;\n  width: 50px;\n  height: 50px;\n  color: var(--blackColor);\n  border-radius: 50%;\n  background-color: var(--whiteColor);\n  position: relative;\n  font-size: 20px;\n  cursor: pointer;\n  transition: var(--transition);\n}\n.team-member-card .team-image .social-btn span i {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  text-align: center;\n  margin-left: -3px;\n}\n.team-member-card .team-image .social-btn ul {\n  padding: 0;\n  margin-bottom: 0;\n  list-style-type: none;\n  position: absolute;\n  right: 0;\n  bottom: 95px;\n}\n.team-member-card .team-image .social-btn ul li {\n  top: 0;\n  right: 0;\n  display: block;\n  position: absolute;\n  transition: var(--transition);\n  transform: scale(0);\n}\n.team-member-card .team-image .social-btn ul li a {\n  display: block;\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  color: var(--whiteColor);\n  position: relative;\n  font-size: 18px;\n  background-color: var(--mainColor);\n  transition: var(--transition);\n}\n.team-member-card .team-image .social-btn ul li a i {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  text-align: center;\n  margin-left: -1px;\n}\n.team-member-card .team-image .social-btn ul li a:hover {\n  background-color: var(--whiteColor);\n  color: var(--mainColor);\n}\n.team-member-card .team-image .social-btn ul li:nth-child(1) {\n  top: -20px;\n}\n.team-member-card .team-image .social-btn ul li:nth-child(2) {\n  top: -80px;\n}\n.team-member-card .team-image .social-btn ul li:nth-child(3) {\n  top: -140px;\n}\n.team-member-card .team-image .social-btn:hover ul li {\n  transform: scale(1);\n}\n.team-member-card .team-content {\n  padding-top: 25px;\n  padding-left: 20px;\n}\n.team-member-card .team-content h3 {\n  font-size: 24px;\n  font-weight: 600;\n  margin-bottom: 0;\n}\n.team-member-card .team-content span {\n  color: var(--mainColor);\n  display: inline-block;\n  margin-top: 12px;\n}\n.team-member-card:hover {\n  transform: translateY(-5px);\n}\n.team-member-card:hover .team-image .social-btn span {\n  color: var(--whiteColor);\n  background-color: var(--mainColor);\n}\n.team-member-card:hover .team-image .social-btn span i {\n  color: var(--whiteColor);\n}\n.team-member-card.with-white-color .team-content h3 {\n  color: var(--whiteColor);\n}\n\n.d-none.d-block {\n  display: block !important;\n}\n\n/* Max width 767px */\n@media only screen and (max-width: 767px) {\n  .team-area.bg-gradient-image {\n    border-bottom: 1px solid #eeeeee;\n  }\n  .single-team-box .content h3 {\n    font-size: 18px;\n  }\n  .team-section-title {\n    padding-left: 0;\n    margin-top: 30px;\n    text-align: center;\n  }\n  .team-section-title .sub-title {\n    margin-bottom: 12px;\n    padding: 3px 15px;\n    font-size: 12px;\n  }\n  .team-section-title h2 {\n    font-size: 25px;\n  }\n  .team-section-title h2 br {\n    display: none !important;\n  }\n  .team-section-title .default-btn {\n    margin-top: 3px;\n  }\n  .team-member-list {\n    padding-right: 0;\n  }\n  .single-team-member .content {\n    border-radius: 0 15px 0 0;\n    padding: 10px 15px;\n  }\n  .single-team-member .content h3 {\n    font-size: 18px;\n  }\n  .team-member-card .team-content h3 {\n    font-size: 20px;\n  }\n}\n/* Min width 576px to Max width 767px */\n/* Min width 768px to Max width 991px */\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n  .team-area.bg-gradient-image {\n    border-bottom: 1px solid #eeeeee;\n  }\n  .single-team-box .content h3 {\n    font-size: 20px;\n  }\n  .team-member-list {\n    padding-right: 0;\n  }\n  .single-team-member .content h3 {\n    font-size: 20px;\n  }\n  .team-section-title {\n    text-align: center;\n    margin-top: 30px;\n    padding-left: 0;\n  }\n  .team-section-title .sub-title {\n    padding: 4px 20px;\n    font-size: 13px;\n  }\n  .team-section-title h2 {\n    font-size: 32px;\n  }\n  .team-section-title h2 br {\n    display: none !important;\n  }\n  .team-section-title .default-btn {\n    margin-top: 5px;\n  }\n}\n/* Min width 992px to Max width 1199px */\n@media only screen and (min-width: 992px) and (max-width: 1199px) {\n  .team-section-title {\n    padding-left: 0;\n  }\n  .single-team-member .content {\n    background-color: transparent;\n    position: relative;\n    border-radius: 0;\n    margin-top: 12px;\n    padding: 0;\n  }\n  .single-team-member .content .d-flex {\n    display: block !important;\n  }\n  .single-team-member .content span {\n    margin-top: 5px;\n  }\n  .single-team-member .content h3 {\n    font-size: 22px;\n  }\n  .team-member-card .team-image .social-btn {\n    right: 5px;\n    bottom: -12px;\n  }\n}\n/* Min width 1200px to Max width 1399px */\n@media only screen and (min-width: 1200px) and (max-width: 1399px) {\n  .team-member-list {\n    padding-right: 0;\n  }\n  .single-team-member .content {\n    padding: 15px;\n  }\n  .single-team-member .content h3 {\n    font-size: 22px;\n  }\n}\n/* Min width 1600px */\n@tailwind base;\n@tailwind components;\n@tailwind utilities;"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
